const imp = () => import(/* webpackChunkName: "loadSprite_task_color"*/  "../sprite/loadSprite_task_color");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Type-1": imp,
  "Icon-Type-2": imp,
  "Icon-Type-3": imp,
  "Icon-Type-4": imp,
  "Icon-Type-5": imp,
  "Icon-Type-6": imp,
  "Icon-Type-7": imp,
  "Icon-Type-8": imp,
  "Icon-Type-9": imp,
  "Icon-Type-10": imp,
  "Icon-Type-11": imp,
  "Icon-Type-12": imp,
  "Icon-Type-13": imp,
  "Icon-Type-14": imp,
  "Icon-Type-15": imp,
  "Icon-Type-16": imp,
  "Icon-Type-17": imp,
  "Icon-Type-18": imp,
  "Icon-Type-19": imp,
  "Icon-Type-20": imp,
}
export default loadMap;